<template>
  <div class="content blacklist">
    <div class="header">
      <el-button type="primary" size="small" @click="dialogFormVisible = true"
        >添加服务类别</el-button
      >
    </div>
    <el-row class="type-center">
      <el-card class="box-card" v-for="(item, idx) in typeArr" :key="idx">
        <div slot="header" class="clearfix">
          <span class="oil-name"> <span>服务名称:</span>{{ item.name }} </span>
          <el-button type="text" @click="delSort(item)">删除</el-button>
          <!-- <el-button type="text" @click="editSort(item)">编辑</el-button> -->
        </div>
        <div class="text item">
          <ol>
            <li>创建时间： {{ item.create_time }}</li>
          </ol>
        </div>
      </el-card>
    </el-row>
    <!--  添加服务类别 -->
    <el-dialog title="新增" :visible.sync="dialogFormVisible" width="400px">
      <el-form :model="form" style="margin-right:60px">
        <el-form-item label="服务名称" :label-width="'80px'">
          <el-input v-model="form.name" autocomplete="off"></el-input>
          <!-- <el-select v-model="form.name">
            <el-option v-for="item in typeList" :key="item.name" :disabled="item.disable" :label="item.name" :value="item.name"></el-option>
          </el-select> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="storeServeAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { storeServeAdd, storeServeDel, storeServeList } from "@/api/storeManage";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      search_con: "",
      form: {
        name: ""
      },
      typeArr: [],
      formLabelWidth: "120px",
      dialogFormVisible: false,
      typeList: [
        { name: "汽油", disable: false },
        { name: "柴油", disable: false },
        { name: "LNG", disable: false },
        { name: "快速买单", disable: false }
      ]
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },
  methods: {
    // 添加服务类别
    storeServeAdd() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        name: this.form.name
      };
      storeServeAdd(data).then(res => {
        this.dialogFormVisible = false;
        if (res.code == 200) {
          this.form.name = "";
          this.$message.success("添加成功");
          this.getList();
        } else {
          this.$message.error("添加失败");
        }
      });
    },
    // 删除类别
    delSort(item) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          let data = {
            token: this.token,
            app_id: this.app_id,
            id: item.id
          };
          storeServeDel(data).then(res => {
            if (res.code == 200) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(_ => {});
    },
    // 服务类别列表
    getList() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      storeServeList(data).then(res => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.typeArr = res.data;
          } else {
            this.$message("暂无数据...");
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  border: 1px solid #f1f1f1;
  height: 100%;
  overflow: auto;
  min-width: 900px;
  background: #f2f2f2;
  // box-shadow: 0 0 3px #f1f1f1;
}
.blacklist {
  padding: 10px 25px;
  .header {
    width: 100%;
    height: auto;
    padding: 10px 10px;
    display: flex;
    align-items: center;
    background: #ffffff;
    .box {
      width: 260px;
      display: flex;
      margin-left: 20px;
      .el-button {
        margin-left: 20px;
      }
    }
  }
}
.type-center {
  margin-top: 10px;
  overflow-y: auto;
  .el-card {
    width: 40%;
    margin-top: 10px;
    .oil-name {
      font-size: 14px;
      color: #333333;
      span {
        margin-right: 10px;
      }
    }
    .el-button {
      float: right;
      margin-left: 10px;
    }
    .el-button:nth-child(2) {
      color: #f56c6c;
    }
  }
}
</style>
